import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../components/ui/card";
import { Label } from "../components/ui/label";
import { Input } from "../components/ui/input";

export const GuestsCard = ({ guests, onChange, t }) => (
  <Card>
    <CardHeader>
      <CardTitle>{t("guests.cardTitle")}</CardTitle>
      <CardDescription>{t("guests.cardDescription")}</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="flex flex-col sm:flex-row sm:items-center sm:gap-3">
        <Label className="sm:w-1/2">{t("guests.label")}</Label>
        <Input
          className="sm:flex-1"
          type="text"
          inputMode="numeric"
          value={guests}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t("guests.placeholder")}
        />
      </div>
    </CardContent>
  </Card>
);
